import AssemblePositioningDeviceModal from './assemble-positioning-device-modal.vue'
export default AssemblePositioningDeviceModal
